import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";

// The hero used to carry a large search box; it was removed in favor of the
// single search entry point in the top nav (⌘K / magnifier) — ticket #9801.
const HubHero: React.FC = () => {
  const userAppSettings = useSelector(
    (state: RootState) => state.userAppSettings.userAppSettings,
  );

  const firstName = userAppSettings?.firstName || "there";

  return (
    <div className="relative overflow-hidden">
      <div className="relative mx-auto max-w-5xl px-4 pt-12 pb-4 sm:px-6 md:pt-16 md:pb-6">
        <div className="text-center">
          {/* Headline - With subtle gradient for depth */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-wide mb-5 bg-gradient-to-b from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent">
            Welcome back, {firstName}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default HubHero;
